// extracted by mini-css-extract-plugin
export var serviceCard = "services-module--serviceCard--JxHs0";
export var iconContainer = "services-module--iconContainer--8avYy";
export var title = "services-module--title--DroH0";
export var description = "services-module--description--iN5p3";
export var ctaLink = "services-module--ctaLink--Si5mi";
export var ctaLinkIcon = "services-module--ctaLinkIcon--P-jZb";